import ContactSummary from "@/components/EmailDashboard/Charts/ContactSummary";
import IncrementalSubscribers from "@/components/EmailDashboard/Charts/IncrementalSubscribers";
import MonthlyMcrMovements from "@/components/EmailDashboard/Charts/MonthlyMcrMovements";
import RepeatPurchaseRevenue from "@/components/EmailDashboard/Charts/RepeatPurchaseRevenue";

interface IProps {
  data: IGetEmailDashboardRS;
}

const ChartGrid = ({ data }: IProps) => {
  return (
    <div className="mb-30 grid grid-cols-1 sm:grid-cols-2 gap-20">
      <MonthlyMcrMovements data={data} />
      <ContactSummary data={data} />
      <IncrementalSubscribers data={data} />
      <RepeatPurchaseRevenue data={data} />
    </div>
  );
};

export default ChartGrid;
